import React, { useEffect, useState } from 'react'
import { ToggleGroup } from '@base-ui/react/toggle-group'
import { Toggle } from '@base-ui/react/toggle'

var DIRECTIONS = [
  { value: 'todos', label: 'Todos' },
  { value: 'entrada', label: 'Entrada' },
  { value: 'salida', label: 'Salida' },
]

var RIDE_TYPES = [
  { value: 'todos', label: 'Todos' },
  { value: 'offer', label: 'Ofrecen cupo' },
  { value: 'request', label: 'Buscan cupo' },
]

export default function FilterBar() {
  var [active, setActive] = useState('todos')

  useEffect(function () {
    if (window.currentFilterDirection) {
      setActive(window.currentFilterDirection)
    }
    var interval = setInterval(function () {
      if (window.currentFilterDirection && window.currentFilterDirection !== active) {
        setActive(window.currentFilterDirection)
      }
    }, 1000)
    return function () { clearInterval(interval) }
  }, [])

  function pick(dir) {
    setActive(dir)
    if (typeof window.setDirectionFilter === 'function') {
      window.setDirectionFilter(dir)
    }
  }

  return (
    <div className="flex items-center bg-slate-100 rounded-xl p-1 gap-0">
      {DIRECTIONS.map(function (d) {
        var isActive = active === d.value
        return (
          <button
            key={d.value}
            onClick={function () { pick(d.value) }}
            className={[
              'flex-1 text-center text-sm font-semibold py-2 px-4 rounded-lg transition-all cursor-pointer',
              isActive
                ? 'bg-white text-slate-900 shadow-xs'
                : 'text-slate-500 hover:text-slate-700'
            ].join(' ')}
          >
            {d.label}
          </button>
        )
      })}
    </div>
  )
}

export function RideTypeFilter() {
  var [active, setActive] = useState('todos')

  useEffect(function () {
    if (window.currentRideType) setActive(window.currentRideType)
    function sync(event) { setActive(event.detail || window.currentRideType || 'todos') }
    window.addEventListener('ride-type-filter-updated', sync)
    return function () { window.removeEventListener('ride-type-filter-updated', sync) }
  }, [])

  function pick(type) {
    setActive(type)
    if (typeof window.setRideTypeFilter === 'function') window.setRideTypeFilter(type)
  }

  return (
    <ToggleGroup
      value={[active]}
      onValueChange={function (values) { if (values[0]) pick(values[0]) }}
      className="flex items-center bg-slate-100 rounded-xl p-1 gap-0"
      aria-label="Tipo de viaje"
    >
      {RIDE_TYPES.map(function (type) {
        var isActive = active === type.value
        return (
          <Toggle
            key={type.value}
            type="button"
            value={type.value}
            className={[
              'flex-1 text-center text-xs font-semibold py-2 px-2 rounded-lg transition-all cursor-pointer',
              isActive ? 'bg-white text-slate-900 shadow-xs' : 'text-slate-500 hover:text-slate-700'
            ].join(' ')}
          >
            {type.label}
          </Toggle>
        )
      })}
    </ToggleGroup>
  )
}
